import { bambiApi as sdkBambiApi } from '@bambi/api-client';
import { configureStore, isPlain } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';

import { rootReducer } from './rootReducer';
import type { RootState } from './types';
import { enhancedBambiApi } from 'src/common/external/bambi-api/enhancedBambiApi';
// Applies the app's tag policy to the api-client singleton before any
// store can dispatch against it; the legacy policy loads the same way via
// enhancedBambiApi above.
import 'src/common/external/api-client/cachePolicy';
import { organizationPersistenceListener } from 'src/features/auth/organizationPersistence.listener';

export function setupStore(preloadedState?: Partial<RootState>) {
  return configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        immutableCheck: { warnAfter: 150 }, // default is 32ms
        serializableCheck: {
          warnAfter: 150, // default is 32ms
          // The generated file endpoints resolve to a File (api-client's
          // fileResponse.ts); it sits in the cache only until the caller
          // lets go of it and is never persisted.
          isSerializable: (value: unknown) =>
            isPlain(value) || value instanceof Blob,
        },
      })
        .prepend(organizationPersistenceListener.middleware)
        .concat(enhancedBambiApi.middleware)
        .concat(sdkBambiApi.middleware),
    preloadedState,
  });
}

// TODO: probably can separate this stuff out, but minimizing scope of change
// by creating the store and keeping it exported below
const store = setupStore();

// From react-toolkit
// optional, but required for refetchOnFocus/refetchOnReconnect behaviors
// see `setupListeners` docs - takes an optional callback as the 2nd arg for customization
setupListeners(store.dispatch);

export default store;
